import { render, staticRenderFns } from "./ElementUnitTableColumn.vue?vue&type=template&id=ffd3d114"
import script from "./ElementUnitTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementUnitTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports